/**
 * Buffer de mensajes del embebedor (embedded-container de xompass-suite).
 *
 * El padre manda HOST_INIT ~100 ms despues del evento load del iframe. Si en ese
 * momento React todavia no monto su listener, el mensaje se pierde: sin HOST_INIT
 * no conocemos el childId, no respondemos CHILD_READY y el padre se queda con su
 * spinner para siempre (solo lo apaga al recibir APP_READY).
 *
 * Este modulo se instala al cargar el bundle, antes de React, y App vacia la cola
 * al montar. Se mantiene escuchando para cubrir el desmontaje/remontaje que hace
 * StrictMode en desarrollo.
 */

const MAX_BUFFERED = 20;
const buffered = [];
let listening = false;

function isHandshakeMessage(event) {
  const data = event?.data;
  if (!data || typeof data !== 'object') return false;
  return Boolean(data.token || data.type === 'HOST_INIT' || data.type === 'HOST_BOOTSTRAP');
}

function collect(event) {
  if (!isHandshakeMessage(event)) return;
  buffered.push(event);
  if (buffered.length > MAX_BUFFERED) buffered.shift();
}

export function startBufferingHostMessages() {
  if (listening || typeof window === 'undefined') return;
  window.addEventListener('message', collect);
  listening = true;
}

/** Reenvia al handler los mensajes llegados antes de montar y limpia la cola. */
export function drainBufferedHostMessages(handler) {
  if (typeof handler !== 'function') return;
  const pending = buffered.splice(0, buffered.length);
  for (const event of pending) {
    try {
      handler(event);
    } catch (_) {
      /* un mensaje malformado no debe cortar el resto */
    }
  }
}
